/**
 * Mobile Bottom Navigation Component
 * One-hand navigation for mobile users
 */
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage, useAuth } from '@/lib/context';
import { 
  Home, Briefcase, Wrench, User, Menu,
  Building2, Settings
} from 'lucide-react';

export default function MobileBottomNav() {
  const { t, language } = useLanguage();
  const { pathname } = useLocation();
  const { user } = useAuth();

  // Direct labels for mobile nav
  const labels = {
    en: { home: 'Home', jobs: 'Jobs', rentals: 'Rent', profile: 'Profile', login: 'Login' },
    et: { home: 'Avaleht', jobs: 'Tööd', rentals: 'Rendid', profile: 'Profiil', login: 'Logi sisse' },
    fi: { home: 'Etusivu', jobs: 'Työt', rentals: 'Vuokraus', profile: 'Profiili', login: 'Kirjaudu' },
    nb: { home: 'Hjem', jobs: 'Jobber', rentals: 'Leie', profile: 'Profil', login: 'Logg inn' },
    ru: { home: 'Главная', jobs: 'Работа', rentals: 'Аренда', profile: 'Профиль', login: 'Войти' },
    sv: { home: 'Hem', jobs: 'Jobb', rentals: 'Uthyrning', profile: 'Profil', login: 'Logga in' },
  };
  const l = labels[language] || labels.en;

  const navItems = [
    { 
      path: '/', 
      icon: Home, 
      label: l.home,
      exact: true 
    },
    { 
      path: '/jobs', 
      icon: Briefcase, 
      label: l.jobs
    },
    { 
      path: '/equipment', 
      icon: Wrench, 
      label: l.rentals
    },
    { 
      path: user ? (user.role === 'company' ? '/company/dashboard' : '/worker/dashboard') : '/login',
      icon: User,
      label: user ? l.profile : l.login
    }
  ];

  const isActive = (path, exact = false) => {
    if (exact) return pathname === path;
    return pathname.startsWith(path);
  };

  return (
    <nav className="mobile-nav" data-testid="mobile-bottom-nav">
      {navItems.map((item) => (
        <Link
          key={item.path}
          to={item.path}
          className={`mobile-nav-item ${isActive(item.path, item.exact) ? 'active' : ''}`}
          data-testid={`nav-${item.label.toLowerCase().replace(/\s/g, '-')}`}
        >
          <item.icon />
          <span>{item.label}</span>
        </Link>
      ))}
    </nav>
  );
}
